var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hide
    ? _c("div", { staticClass: "form-network form-network-pinterest" }, [
        _c("details", { attrs: { open: "" } }, [
          _c("summary", [
            _vm._v(
              _vm._s(_vm.$t("dash.post-creator.form.pinterest.select-board")) +
                " "
            ),
            _c("i", { staticClass: "fa-solid fa-caret-down" }),
          ]),
          _c("div", { staticClass: "content-detail" }, [
            _c(
              "div",
              { staticClass: "selects" },
              [
                _c("SelectComponent", {
                  attrs: {
                    valueSelect: _vm.inputModel.pageIdSelectBoardSelect,
                    changeValueSelect: (v) =>
                      (_vm.inputModel.pageIdSelectBoardSelect = v),
                    data: _vm.pagePinterestSelectedForSelect,
                    positionAuto: false,
                    positionX: "left",
                  },
                }),
                _c("SelectComponent", {
                  attrs: {
                    valueSelect:
                      _vm.boardsPages[_vm.inputModel.pageIdSelectBoardSelect] &&
                      _vm.boardsPages[_vm.inputModel.pageIdSelectBoardSelect]
                        .length
                        ? _vm.draftInstance.form.networks.pinterest
                            .boardSelectedByPage[
                            _vm.inputModel.pageIdSelectBoardSelect
                          ]
                          ? _vm.draftInstance.form.networks.pinterest
                              .boardSelectedByPage[
                              _vm.inputModel.pageIdSelectBoardSelect
                            ]
                          : "unselected"
                        : "none",
                    changeValueSelect: _vm.selectBoard,
                    data:
                      _vm.boardsPages[_vm.inputModel.pageIdSelectBoardSelect] &&
                      _vm.boardsPages[_vm.inputModel.pageIdSelectBoardSelect]
                        .length
                        ? {
                            ...(!_vm.inputModel.boardSelectedPerPage[
                              _vm.inputModel.pageIdSelectBoardSelect
                            ]
                              ? {
                                  unselected: _vm.$t(
                                    "dash.post-creator.form.pinterest.none-selected"
                                  ),
                                }
                              : {}),
                            ...Object.fromEntries(
                              _vm.boardsPages[
                                _vm.inputModel.pageIdSelectBoardSelect
                              ].map((board) => [board.id, board.name])
                            ),
                          }
                        : {
                            none: _vm.$t(
                              "dash.post-creator.form.pinterest.no-board"
                            ),
                          },
                    positionAuto: false,
                    positionX: "left",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _c("details", { attrs: { open: "" } }, [
          _c("summary", [
            _vm._v(
              _vm._s(_vm.$t("dash.post-creator.form.pinterest.create-board")) +
                " "
            ),
            _c("i", { staticClass: "fa-solid fa-caret-down" }),
          ]),
          _c("div", { staticClass: "content-detail" }, [
            _c(
              "div",
              { staticClass: "selects" },
              [
                _c("SelectComponent", {
                  attrs: {
                    valueSelect: _vm.inputModel.pageIdSelectBoardCreate,
                    changeValueSelect: (v) =>
                      (_vm.inputModel.pageIdSelectBoardCreate = v),
                    data: {
                      all: _vm.$t(
                        "dash.post-creator.form.pinterest.all-accounts"
                      ),
                      ..._vm.pagePinterestSelectedForSelect,
                    },
                    positionAuto: false,
                    positionX: "left",
                  },
                }),
                _c("div", { staticClass: "type-input" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.inputModel.valueNewBoard,
                        expression: "inputModel.valueNewBoard",
                      },
                    ],
                    attrs: {
                      placeholder: _vm.$t(
                        "dash.post-creator.form.pinterest.board-name"
                      ),
                    },
                    domProps: { value: _vm.inputModel.valueNewBoard },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return (() => _vm.createBoard()).apply(null, arguments)
                      },
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.inputModel,
                          "valueNewBoard",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
              ],
              1
            ),
          ]),
        ]),
        _c("details", { attrs: { open: "" } }, [
          _c("summary", [
            _vm._v(
              _vm._s(_vm.$t("dash.post-creator.form.pinterest.select-link"))
            ),
            _c("i", { staticClass: "fa-solid fa-caret-down" }),
          ]),
          _c("div", { staticClass: "content-detail form-link" }, [
            _c(
              "div",
              { staticClass: "list-thubmmail" },
              _vm._l(
                _vm.draftInstance.form.urlsTextContentHistory,
                function (url) {
                  return _c(
                    "div",
                    {
                      key: url.value,
                      staticClass: "thubmmail",
                      on: { click: () => _vm.selectUrl(url.value) },
                    },
                    [
                      _c("Checkbox", {
                        attrs: {
                          id: url.value,
                          prefixId: "thubmmail-",
                          isChecked:
                            _vm.draftInstance.form.networks.pinterest.snippet
                              .link == url.value,
                          isDisable:
                            _vm.draftInstance.form.networks.pinterest.snippet
                              .link == url.value,
                          add: _vm.selectUrl,
                          remove: () => {},
                        },
                      }),
                      _c("SnippetNetwork", { attrs: { link: url.value } }),
                    ],
                    1
                  )
                }
              ),
              0
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }